import { createStore, useStore as baseUseStore } from 'vuex';
import { generalStore as general } from '@/store/generalStore';
import { GeneralState } from '@/models/Interfaces';

export const generalStore = createStore(general);
export default generalStore;

export function useStore() {
    return baseUseStore<GeneralState>();
}
